<template>
    <div class="home-form">
        <van-nav-bar class="nav-bar" title="企业用户" left-text="返回" left-arrow @click-left="$router.push({path:'/mobileRegister'})" />
        <el-form ref="company" :model="formData"  :rules="rules" label-width="100px">

            <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="formData.companyName" class="handle-input" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contactName">
                <el-input v-model="formData.contactName" class="handle-input" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="formData.contactPhone" class="handle-input" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idCard">
                <el-input v-model="formData.idCard" class="handle-input" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="营业执照" prop="business">
                <el-upload
                    ref="uploadCompany"
                    class="upload-demo"
                    :action="`${this.$http.defaults.baseURL}/img/upload`"
                    :on-success="handleSuccess"
                    >
                    <el-button size="small" type="primary">上传文件</el-button>
                    <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="formData.email" class="handle-input" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
                <el-input v-model="formData.userName" class="handle-input" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="passWord">
                <el-input v-model="formData.passWord" class="handle-input" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassWord">
                <el-input v-model="formData.confirmPassWord" class="handle-input" placeholder="请再次输入密码"></el-input>
            </el-form-item>
            <el-form-item label="渠道推荐码">
                <el-input v-model="formData.channelCode" class="handle-input" placeholder="请输入渠道推荐码"></el-input>
            </el-form-item>
            
        </el-form>
        <el-button @click="getRegisterCompany">提 交</el-button>
    </div>
</template>

<script>
import {
    registerDemandCompany
} from "@/api/index";
import { Toast } from 'vant';

export default {
    data() {
        var validatePass = (rule, value, callback) => {
			if(value === "" || value === null){
                callback(new Error("请输入确认密码"));
            }else if(this.formData.passWord !== value){
                callback(new Error("两次输入密码不一致"));
            }else {
                callback();
            }
		};
        return {
            formData:{
                companyName:'',//公司名称
                contactName:'',//联系人
                contactPhone:'',//联系电话
                idCard:'',//身份证号码
                business:'',//营业执照
                email:'',//电子邮箱
                userName:'',//用户名
                passWord:'',//密码
                confirmPassWord:'',//确认密码
                channelCode:'',//渠道推荐码
            },
            rules:{
                companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                contactName: [
                    { required: true, message: '请输入联系人', trigger: 'blur' }
                ],
                contactPhone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    //联系电话正则验证
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: '请输入正确的联系电话',
                        trigger: 'blur'
                    }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号码', trigger: 'blur' },
                    //身份证号正则验证
                    {
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: '请输入正确的身份证号码',
                        trigger: 'blur'
                    }
                ],
                business: [
                    { required: true, message: '请上传营业执照', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入电子邮箱', trigger: 'blur' },
                    //电子邮箱正则验证
                    {
                        pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                        message: '请输入正确的电子邮箱',
                        trigger: 'blur'
                    }
                ],
                userName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                passWord: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                confirmPassWord: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    //确认密码 与 密码 保持一致
                    {
                        validator: validatePass,
                        trigger: 'blur'
                    }
                ],
            }
        } 
    },
    methods:{
        handleSuccess(res){
            Toast.success ('上传成功');
            this.formData.business = res.data;
        },
        getRegisterCompany(){
            this.$refs['company'].validate(valid => {
                if (valid) {
                    this.registerCompany();//表单必填验证通过  提交表单
                } else {
                    return false;
                }
            });
        },
        registerCompany(){
            let paramObj = {
                account:this.formData.userName,//账号
                password:this.formData.passWord,//密码
                company:this.formData.companyName,//公司名称
                linkName:this.formData.contactName,//联系人
                linkPhone:this.formData.contactPhone,//联系电话
                idCard:this.formData.idCard,//身份证号码
                businessLicense:this.formData.business,//营业执照
                email:this.formData.email,//电子邮箱
                channelStr:this.formData.channelCode,//渠道推荐码
            }
            registerDemandCompany(paramObj).then(res=>{
                if(res.data){
                    Toast.success('注册信息提交成功,请等待管理员进行审核');

                    this.$refs.company.resetFields();//清空表单验证
                    this.$refs.uploadCompany.clearFiles();//清空 el-upload 上传的列表
                    this.$router.push('/')
                }else {
                    Toast.fail('注册失败')

                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.el-form{
    margin-top:10px;
    padding:0 10px;
}
.home-form{
    width:100%;
    height:auto;
    margin:0 auto;
    // padding:0 10px;
    .handle-input{
        // width:200px;
    }
    button{
        width:150px;
        height:40px;
        border:0;
        outline:none;
        color:#fff;
        margin:0 auto;
        border-radius:5px;
        background-color:#0066ff;
        cursor:pointer;
        margin-left:35%;
    }
}
</style>
<style scoped>
::v-deep .el-form-item__label{
    line-height:20px !important;
}
/* ::v-deep .el-form-item{
    margin-bottom:10px !important;
} */
::v-deep .el-upload-dragger{
    width:570px;
    height:120px;
}
::v-deep .el-upload-dragger .el-icon-upload {
    margin:15px 0;
}
</style>
